import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, Highchartscomponent} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';


Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});

const skills2 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Software engineering', 'Data science', 'Product management','Sales','Marketing','UI/UX','Startup trainers','Leadership','HR', ]
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [  {
        name: 'VC/Investor',
        data: [7, 9, 3, 1, 1, 0, 0, 1, 0]
    },{
        name: 'Founder',
        data: [26, 10, 7, 6, 2, 1, 1, 0, 1]
    },{
        name: 'Community builder',
        data: [5, 5, 2, 2, 1, 0, 0, 0, 1]
    }]
}



export class ChapterFiftyTwo extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>

        <TextHolder text="Software engineering is the number one skill needed in SEA, according to our survey. Data science is a far second followed by product management." />
        <TextHolder text="" />



          <Highchartscomponent   chartsText="Which functional skill sets are most challenging to hire?"  options={skills2} source="Source: 2018 State of SE Asian Tech Survey" />




          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/52.js